import styled from 'styled-components';
import SelectableButtonComponent from '../../../../components/selectable-button';

export const VariantGroupWrapper = styled.div`
  padding-left: 2px;
`;

export const VariantGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 2px;
`;

type SelectableButtonProps = {
  selected: boolean;
};

export const SelectableButton = styled(SelectableButtonComponent)<
  SelectableButtonProps
>`
  display: flex;
  min-height: 40px;
  min-width: 80px;
  background-color: ${props => props.theme.buttons.category.bg};
`;
